import { forwardRef } from "react";
import { animated } from "react-spring";
import { useReveal } from "../../../hooks/useReveal.jsx";
import tokens from "../../tokens";
import { spinnerStyles } from "./spinner.css.js";

export const RawSpinner = forwardRef(({ size = 16, style, ...rest }, ref) => (
  <svg
    style={{
      width: Math.min(150, size),
      height: Math.min(150, size),
      ...style,
    }}
    viewBox="0 0 40 40"
    xmlns="http://www.w3.org/2000/svg"
    stroke={tokens.color.full.gray500}
    {...rest}
    ref={ref}
  >
    <g className={spinnerStyles.g} strokeWidth="4" fill="none">
      <circle strokeOpacity=".25" cx="20" cy="20" r="18" />
      <path d="M38 20A18 18 0 0 0 20 2" />
    </g>
  </svg>
));

RawSpinner.displayName = "RawSpinner";

export const Spinner = () => (
  <div className={spinnerStyles.container}>
    <RawSpinner size={40} />
  </div>
);

const AnimRawSpinner = animated(RawSpinner);

export const RevealSpinner = ({ show }) => {
  const reveal = useReveal(show);
  return reveal((props) => (
    <div className={spinnerStyles.container}>
      <AnimRawSpinner
        size={40}
        style={{
          opacity: props.value,
          transform: props.value.to((v) => `scale(${v / 2 + 0.5})`),
        }}
      />
    </div>
  ));
};
